import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VModal from "vue-js-modal";
import VTooltip from "v-tooltip";
import VueSocialSharing from "vue-social-sharing";
import vSelect from "vue-select";
import vueHeadful from "vue-simple-headful";

var VueScrollTo = require("vue-scrollto");

Vue.use(VModal);
Vue.use(VTooltip);
Vue.use(VueSocialSharing);
Vue.component("v-select", vSelect);
Vue.use(vueHeadful, {
  component: true
});

Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
